export const COMPANY_WITHIN_RESET = "RESET";
export const COMPANY_WITHIN_SET_LOADING = "SET_LOADING";
export const COMPANY_WITHIN_APPLY_FILTER = "COMPANY_WITHIN_APPLY_FILTER";

export const INITIAL_STATE = {
    isLoading: false
};

export function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case COMPANY_WITHIN_RESET:
            return INITIAL_STATE;
        case COMPANY_WITHIN_APPLY_FILTER:
            return {...state, filter: action.payload.filter};
        case COMPANY_WITHIN_SET_LOADING:
            const isLoading = action.payload.isLoading;
            return {...state, isLoading: isLoading };
        case "SUBSCRIPTION_DATA_ARRIVED/EXPLORE_COMPANY_CUSTOM_GROUPING":
            const payload = action.payload;
            return {...state, ...payload, failure: null, isLoading: false};
        case "SUBSCRIPTION_DATA_FAILED/EXPLORE_COMPANY_CUSTOM_GROUPING":
            return {...state, failure: action.payload, isLoading: false};
        default:
            return state;
    }
}

export default dispatch => ({
    setLoading(isLoading) {
        dispatch({type: COMPANY_WITHIN_SET_LOADING, payload: {isLoading}});
    },
    reset() {
        dispatch({type: COMPANY_WITHIN_RESET});
    },
    applyFilter(filter) {
        dispatch({type: COMPANY_WITHIN_APPLY_FILTER, payload: {filter}})
    }
});
